import axiosInstance from '../helpers/axios.helper';

const getLeadOwners = (options = {}) => {
  return axiosInstance.get('api/v1/lead_owners.json', {}, options);
};

export const leadOwnersService = {
  getLeadOwners
};



// WEBPACK FOOTER //
// ./src/services/leadOwners.service.js